module.exports = __webpack_public_path__ + "media/images/new_culture/bg-2-b2963782ac799644f6200a125c303e49.jpeg";